export default __webpack_public_path__ + "static/media/castle_dragons_banner.46d024c0.jpg";